export default __webpack_public_path__ + "static/media/robin_2.467570fa.mp3";